import { createFileRoute } from "@tanstack/react-router";
import { ExamForm } from "@client/components/ExamForm";

export const Route = createFileRoute("/_authenticated/exams/$examId/edit")({
  component: EditExamPage,
});

function EditExamPage() {
  const { examId } = Route.useParams();
  return <ExamForm examId={examId} />;
}
